import axios from 'axios';
import { REACT_APP_WORKING_URL } from '../Constants'
import { REACT_APP_WORKING_CHATAPI_URL } from '../Constants'


export const updateQuestion = async (id, data)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.put(`${REACT_APP_WORKING_URL}quiz/updateQuestion/${id}`,data,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getImgsInRelatePagesByDocid = async (question_id, page)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getImgsInRelatePagesByDocid/${question_id}/${page}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const updateQuestionUrl = async (question_id, imgs)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.put(`${REACT_APP_WORKING_URL}quiz/updateQuestionUrl/${question_id}`, {
        url: imgs
    },{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getPublicQuiz = async (user_id, lan)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getPublicQuiz/${user_id}/${lan}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getPublicQuizForTempUser = async (lan)=>{
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getPublicQuizForTempUser/${lan}`);
    return res.data;
}



export const getPublicQuizCount = async (lan)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getPublicQuizCount/${lan}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getPublicQuizCorrectCount = async (user_id, lan)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getPublicQuizCorrectCount/${user_id}/${lan}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getPublicQuizIncorrectCount = async (user_id, lan)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getPublicQuizIncorrectCount/${user_id}/${lan}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

